import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddOrganizationMutationVariables = Types.Exact<{
  input: Types.Organizations_Insert_Input;
}>;


export type AddOrganizationMutation = { __typename?: 'mutation_root', insert_organizations_one?: { __typename?: 'organizations', id: any, name: string, contact_name?: string | null, email?: string | null, organizationImageURL?: string | null, workspace_id: any, type?: string | null, jurisdiction_id?: any | null, created_at?: any | null, updated_at?: any | null, jurisdiction?: { __typename?: 'jurisdictions', id: any, name: string, short_name: string, state: string, ahj_type: string } | null } | null };


export const AddOrganizationDocument = gql`
    mutation addOrganization($input: organizations_insert_input!) {
  insert_organizations_one(object: $input) {
    id
    name
    contact_name
    email
    organizationImageURL
    workspace_id
    type
    jurisdiction_id
    jurisdiction {
      id
      name
      short_name
      state
      ahj_type
    }
    created_at
    updated_at
  }
}
    `;
export type AddOrganizationMutationFn = Apollo.MutationFunction<AddOrganizationMutation, AddOrganizationMutationVariables>;

/**
 * __useAddOrganizationMutation__
 *
 * To run a mutation, you first call `useAddOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrganizationMutation, { data, loading, error }] = useAddOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<AddOrganizationMutation, AddOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOrganizationMutation, AddOrganizationMutationVariables>(AddOrganizationDocument, options);
      }
export type AddOrganizationMutationHookResult = ReturnType<typeof useAddOrganizationMutation>;
export type AddOrganizationMutationResult = Apollo.MutationResult<AddOrganizationMutation>;
export type AddOrganizationMutationOptions = Apollo.BaseMutationOptions<AddOrganizationMutation, AddOrganizationMutationVariables>;